import { Box, Stack, Snackbar, Alert, Typography, Card, CardHeader, CardContent, TextField, Grid2, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import React, { useState } from "react";
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase } from "../../config/apiBase";
import { useAuth } from "../../contexts/AuthContext";
import CommentIcon from '@mui/icons-material/Comment';
import SendIcon from '@mui/icons-material/Send';
import AsyncButton from "../../components/common/AsyncButton";

const Feedback = () => {
    const { user, logout } = useAuth();
    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const [feedback, setFeedback] = useState("")
    const [category, setCategory] = useState("Suggestions")

    const handleChange = (e) => {
        setFeedback(e.target.value)
    }

    const handleCategoryChange = (e) => {
        setCategory(e.target.value)
    }
    const handleNext = async (e) => {
        e.preventDefault();
        if (!feedback.trim()) {
            setState({ open: true, severity: "warning", message: "Please enter your feedback before submitting" })
            return;
        }
        await InvokeAPI(`${getUserMgmtBase()}/v1/user/feedback/create`,
            {
                "UserID": user.id,
                "Feedback": feedback,
                "Category": category,
            },
            'POST',
            { "authorization": user["token"] },
            false).then(data => {
                setFeedback("");
                setCategory("Suggestions");
                setState({ open: true, severity: "success", message: "Feedback submitted successfully" })
            })
    }
    return (
        <Box sx={{ paddingBottom: '80px' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={3000}
            >
                <Alert variant="filled" severity={state.severity}>
                    {state.message}
                </Alert>
            </Snackbar>
            <Grid2 container spacing={2} justifyContent="center">
                <Grid2 size={{ xs: 12, sm: 10, md: 8, lg: 6 }}>
                    <Card 
                        elevation={6}
                        sx={{
                            borderRadius: 4,
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                                boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                transform: 'translateY(-2px)',
                            },
                        }}
                    >
                        <CardHeader 
                            sx={{ textAlign: 'center', pb: 1 }}
                            title={
                                <Typography 
                                    sx={{ 
                                        fontWeight: 600,
                                        fontSize: '1.125rem',
                                        color: 'text.primary',
                                        letterSpacing: '-0.01em',
                                        textAlign: 'center',
                                        width: '100%'
                                    }} 
                                    variant="h6"
                                >
                                    Submit Feedback
                                </Typography>
                            } 
                        />
                        <CardContent sx={{ pt: 3 }}>
                            <Stack spacing={3}>
                                <Box>
                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                        <InputLabel id="feedback-category-label">Category</InputLabel>
                                        <Select
                                            labelId="feedback-category-label"
                                            id="feedback-category"
                                            value={category}
                                            label="Category"
                                            onChange={handleCategoryChange}
                                        >
                                            <MenuItem value="Suggestions">Suggestions</MenuItem>
                                            <MenuItem value="Complaint">Complaint</MenuItem>
                                            <MenuItem value="Appreciation">Appreciation</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
                                        <CommentIcon color="primary" />
                                        <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                            Please share your feedback on how we can improve this further
                                        </Typography>
                                    </Stack>
                                    <TextField
                                        name="feedback"
                                        value={feedback}
                                        onChange={handleChange}
                                        placeholder="Your feedback is important to us! Share your thoughts, suggestions, or any issues you've encountered..."
                                        multiline
                                        rows={10}
                                        fullWidth
                                        variant="outlined"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: 2,
                                                backgroundColor: 'background.paper',
                                                '& fieldset': {
                                                    borderColor: 'divider',
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: 'primary.main',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'primary.main',
                                                    borderWidth: '2px',
                                                },
                                            },
                                            '& .MuiInputBase-input': {
                                                fontSize: '0.95rem',
                                                lineHeight: 1.6,
                                            },
                                        }}
                                    />
                                </Box>
                                <Box display="flex" justifyContent="center" alignItems="center" sx={{ pt: 1 }}>
                                    <AsyncButton 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={handleNext}
                                        startIcon={<SendIcon />}
                                        sx={{
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            fontSize: '1rem',
                                            px: 4,
                                            py: 1.5,
                                            borderRadius: 2,
                                            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                                            '&:hover': {
                                                boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
                                                transform: 'translateY(-2px)',
                                            },
                                            transition: 'all 0.2s ease-in-out',
                                        }}
                                    >
                                        Submit Feedback
                                    </AsyncButton>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid2>
            </Grid2>
        </Box>
    )
}

export default Feedback;